var lx = lx || {};
lx.action = lx.action || {};
lx.action.doc = lx.action.doc || {};
lx.action.item = lx.action.item || {};
lx.action.helpdesk = lx.action.helpdesk || {};

//runAction = lx.action.doc.runEdit
var vRunActionRefresh;

/**
 * Return a stable selector for the element that initiated a document action.
 * APEX 24.2 requires a selector (rather than a JavaScript expression) so that
 * Dialog Closed events and focus restoration are associated with that element.
 */
lx.action.doc.getTriggerSelector = function (pTrigger) {
    var vElement = pTrigger && pTrigger.jquery ? pTrigger[0] : pTrigger;
    var vId;

    if (typeof vElement === "string" && vElement !== "this") {
        try {
            vElement = document.querySelector(vElement);
        } catch (ignore) {
            vElement = null;
        }
    }

    if (vElement && vElement.target && vElement.target.nodeType === 1) {
        vElement = vElement.currentTarget || vElement.target;
    }

    if ((!vElement || vElement.nodeType !== 1) &&
            document.activeElement &&
            document.activeElement !== document.body &&
            document.activeElement !== document.documentElement) {
        vElement = document.activeElement;
    }

    if (!vElement || vElement.nodeType !== 1 ||
            vElement === document.body ||
            vElement === document.documentElement) {
        return null;
    }

    if (!vElement.id || (document.getElementById(vElement.id) && document.getElementById(vElement.id) !== vElement)) {
        do {
            lx.action.doc.triggerSequence = (lx.action.doc.triggerSequence || 0) + 1;
            vId = "lx_doc_action_trigger_" + lx.action.doc.triggerSequence;
        } while (document.getElementById(vId));
        vElement.id = vId;
    }

    return "#" + apex.util.escapeCSS(vElement.id);
};

/**
 * APEX 24.2 action URLs require trgEl to contain a CSS selector. Keep existing
 * valid selectors intact and replace only the legacy JavaScript expression.
 */
lx.action.doc.normalizeDialogAction = function (pAction, pSelector) {
    return pAction.replace(
        /((?:[?&]|&amp;)trgEl=)this(?=(?:&|&amp;|$))/g,
        "$1" + encodeURIComponent(pSelector)
    );
};

lx.action.doc.openDialogAction = function (pAction, pTrigger) {
    var vSelector = lx.action.doc.getTriggerSelector(pTrigger);
    var vAction;

    if (!vSelector) {
        if (apex.debug && apex.debug.error) {
            apex.debug.error("Cannot open the modal dialog without a triggering element.");
        }
        return false;
    }

    vAction = lx.action.doc.normalizeDialogAction(pAction, vSelector);

    apex.navigation.dialog(vAction, {}, "", vSelector);
    return true;
};

/**
 * Find an APEX modal action attached directly to a clickable control. Inline
 * action URLs are invalid JavaScript in current browsers; legacy trgEl=this is
 * also unsupported by APEX 24.2. This deliberately inspects URL-bearing
 * attributes only and never depends on translated labels or menu text.
 */
lx.action.doc.getDialogAction = function (pElement) {
    var vAttributes = ["data-action", "href", "onclick"];
    var vIndex;
    var vValue;
    var vMatch;

    for (vIndex = 0; vIndex < vAttributes.length; vIndex += 1) {
        vValue = pElement.getAttribute(vAttributes[vIndex]);
        if (!vValue) {
            continue;
        }

        vMatch = vValue.match(/^\s*(?:javascript:\s*)?(#action\$a-dialog-open[^;]*?)\s*;?\s*$/i);
        if (vMatch) {
            return {
                attribute: vAttributes[vIndex],
                action: vMatch[1]
            };
        }
    }

    return null;
};

/**
 * Delegated capture handling also covers controls created by partial page
 * refreshes. Unsafe inline actions are converted to data-action and executed
 * with the selector of the control that was actually clicked.
 */
lx.action.doc.installDialogActionCompatibility = function () {
    if (lx.action.doc.dialogActionCompatibilityInstalled) {
        return;
    }

    lx.action.doc.dialogActionCompatibilityInstalled = true;
    document.addEventListener("click", function (pEvent) {
        var vElement = pEvent.target && pEvent.target.closest ?
            pEvent.target.closest("[data-action],a[href],button[href],[onclick]") : null;
        var vDescriptor;
        var vSelector;
        var vAction;
        var vNeedsCompatibility;

        if (!vElement) {
            return;
        }

        vDescriptor = lx.action.doc.getDialogAction(vElement);
        if (!vDescriptor) {
            return;
        }

        vNeedsCompatibility = vDescriptor.attribute === "onclick" ||
            /(?:[?&]|&amp;)trgEl=this(?=(?:&|&amp;|$))/i.test(vDescriptor.action) ||
            vElement.getAttribute("data-lx-dialog-action-compat") === "Y";

        if (!vNeedsCompatibility) {
            return;
        }

        vSelector = lx.action.doc.getTriggerSelector(vElement);
        vAction = lx.action.doc.normalizeDialogAction(vDescriptor.action, vSelector);

        vElement.setAttribute("data-action", vAction);
        vElement.setAttribute("data-lx-dialog-action-compat", "Y");
        if (vDescriptor.attribute === "onclick") {
            vElement.removeAttribute("onclick");
        }

        pEvent.preventDefault();
        pEvent.stopImmediatePropagation();
        apex.navigation.dialog(vAction, {}, "", vSelector);
    }, true);
};

lx.action.doc.installDialogActionCompatibility();

/**
 * Execute a response returned by DOCUMENT_ACTION_MSG.
 * APEX action URLs are opened by the supported navigation API. Other responses
 * are legacy JavaScript commands (currently report execution) and retain their
 * existing behavior until the server response is converted to typed JSON.
 */
lx.action.doc.executeMessage = function (pMessage, pTrigger) {
    if (pMessage.indexOf("#action$") === 0) {
        lx.action.doc.openDialogAction(pMessage, pTrigger);
    } else {
        eval(pMessage);
    }
};

function runAction(p_aka, pDocId, pRefresh) {
	
    $s("P0_ACTION", p_aka);
    vRunActionRefresh = pRefresh;
    lx.load.add();
	
    apex.server.process("DOCUMENT_ACTION_MSG", {
        x01: p_aka,
        x02: $v("P" + $v('pFlowStepId') + "_ID")
    }, {
            dataType: 'text',
            success: function (dMsg) {
                lx.load.remove();
                var vMsg = dMsg;
                var vChkFooter = vMsg.substr(0, vMsg.indexOf(':'));
                vMsg = vMsg.replace(vChkFooter + ':', '');
                //console.log('1_vChkFooter='+vChkFooter);
                if (vChkFooter == 'RS' || vChkFooter == 'EMAIL' || vChkFooter == 'PRINT' || vChkFooter == 'PRINT_O' || vChkFooter == 'PRINT_I' || vChkFooter == 'LINK_DOC') {
                    lx.action.doc.executeMessage(vMsg, pRefresh);
                    return;
                }
                if (vChkFooter == 'COM') {
                   /* var dialogDiv = '<div id="test"><br/>&nbsp;Reason' + ':<textarea id="actionReason" style="width:380px;height:40px;"></textarea></div>';*/
					var dialogDiv = '<div id="test" style="height:110px;padding:16px;background-color: #e7e7e7;"><div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--info t-Alert" style="height: 56px;"><div class="t-Alert-wrap"><div class="t-Alert-icon" style="padding:1.2rem 1.6rem;"><span class="t-Icon"></span></div><div style="width:100%;padding:1.2rem 1.2rem 1.2rem 0rem;">' + lx.tran.get("DOC_AUTH_REJECTION") + '</div></div></div><div style="padding: 24px 24px 20px 24px;background-color: #ffffff;">' + '<textarea id="actionReason" style="width:100%;height: 60px;" placeholder="Comment"></textarea></div></div>';
                    apex.jQuery(dialogDiv).dialog({
                        modal: true,
                        resizable: false,
                        /*title: "Reject document",*/
                        width: 690,
                        buttons: [{ text: lx.tran.get("DOC_AUTH_REJECT_BTN"), click: function () { apex.submit({ request: "APPLY_ACTION_CHANGES", set: { "P0_ACTION_COM": $v("actionReason") } }); } }
                            , { text: lx.tran.get("CANCEL_BTN"), click: function () { apex.jQuery(this).dialog("close"); } }]
                    });
                } else if (vChkFooter == 'ND') {
                    // Copy document dialog
                    var vArray = vMsg.split(':');
                   // var dialogDiv = '<div id="test"><br/>&nbsp;Choose type of the document</div>'; //apex.lang.getMessage("JS23")
					var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert" style="margin:1.6rem;"><div class="t-Alert-wrap"><div class="t-Alert-icon" style="padding:1.2rem 1.6rem;"><span class="t-Icon"></span></div><div style="width:100%;padding:1.2rem 1.2rem 1.2rem 0rem;">'+ lx.tran.get('CHOOSE_DOC_TYPE') +'</div></div></div>';
                    var dialog_buttons = {};
                    var vCancel = lx.tran.get('CANCEL_BTN'); //apex.lang.getMessage("JS24");
                    // Note by Davor on 24.03.2020 > WTF ... way in which this is coded has 0 flexibility... vMsg is generated dynamic from db (HR docs) and this is fixed to array numbers
                    //                               needs a complete rewrite... for passing so much different data we should always use structured json.. multiple buttons in a for loop (this sphageti code is killing readibility)
                    if (vArray.length == 9) {
                        dialog_buttons[vCancel] = function () {
                            apex.jQuery(this).dialog('close');
                        }
                        dialog_buttons[vArray[1]] = function () {
                            $s("P0_DOC_TYPE", vArray[4]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[0]] = function () {
                            $s("P0_DOC_TYPE", vArray[3]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[2]] = function () {
                            $s("P0_DOC_TYPE", vArray[5]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        apex.jQuery(dialogDiv).dialog({
                            modal: true,
                            resizable: false,
                            /*title: vArray[6],*/
                            width: 600,
                            buttons: dialog_buttons
                        });
                    }
                    // HR Documents
                    else if (vArray.length == 29) {
                        dialog_buttons[vArray[0]] = function () {
                            $s("P0_DOC_TYPE", vArray[13]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[1]] = function () {
                            $s("P0_DOC_TYPE", vArray[14]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[2]] = function () {
                            $s("P0_DOC_TYPE", vArray[15]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[3]] = function () {
                            $s("P0_DOC_TYPE", vArray[16]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[4]] = function () {
                            $s("P0_DOC_TYPE", vArray[17]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[5]] = function () {
                            $s("P0_DOC_TYPE", vArray[18]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[6]] = function () {
                            $s("P0_DOC_TYPE", vArray[19]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[7]] = function () {
                            $s("P0_DOC_TYPE", vArray[20]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[8]] = function () {
                            $s("P0_DOC_TYPE", vArray[21]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[9]] = function () {
                            $s("P0_DOC_TYPE", vArray[22]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[10]] = function () {
                            $s("P0_DOC_TYPE", vArray[23]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[11]] = function () {
                            $s("P0_DOC_TYPE", vArray[24]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[12]] = function () {
                            $s("P0_DOC_TYPE", vArray[25]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vCancel] = function () {
                            apex.jQuery(this).dialog('close');
                        }
                        apex.jQuery(dialogDiv).dialog({
                            modal: true,
                            resizable: false,
                            title: vArray[26],
                            width: 500,
                            buttons: dialog_buttons
                        });
                    }
                    else {
                        dialog_buttons[vArray[0]] = function () {
                            $s("P0_DOC_TYPE", vArray[2]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vArray[1]] = function () {
                            $s("P0_DOC_TYPE", vArray[3]);
                            apex.submit("APPLY_ACTION_CHANGES");
                            $x("P0_DOC_TYPE").value = '';
                        }
                        dialog_buttons[vCancel] = function () {
                            apex.jQuery(this).dialog('close');
                        }

                        apex.jQuery(dialogDiv).dialog({
                            modal: true,
                            resizable: false,
                            title: vArray[4],
                            width: 690,
                            buttons: dialog_buttons
                        });
                    }
                }
                if (vChkFooter != 'ND' && vChkFooter != 'RS' && vChkFooter != 'EMAIL' && vChkFooter != 'COM') {
                    var vMsgConfirm;
                    // Line bellow was added to prevent showing document code that was concated to the end 
                    // of return statement of pkg_documents.get_warning_msg function.
                    vMsg = vMsg.substr(0, vMsg.indexOf(':'));
                    if (vMsg.indexOf("NO_MSG") == -1) vMsgConfirm = confirm(vMsg);
                    else vMsgConfirm = true;
                    if (vMsgConfirm) {
                        var vDocProc2 = '';
                        if (vChkFooter == 'CLD-INV,0' || vChkFooter == 'CLD-INV,1') {
                            if (confirm(apex.lang.getMessage("JS1")) == true) {
                                vDocProc2 = '1';
                                vChkFooter = vChkFooter.replace('CLD-INV,', '');
                            } else {
                                vChkFooter = '0';
                                vDocProc2 = '0';
                            }
                        }
                        if (vChkFooter == '1') {
                            if (confirm(apex.lang.getMessage("CHANGE_FOOTER_TEXT")) == false) vChkFooter = '0';
                        }
                        if (vRunActionRefresh == 'Y') {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: $v("P0_ACTION"),
                                x02: $v("P" + $v('pFlowStepId') + "_ID"),
                                x03: vChkFooter,
                                x05: vDocProc2,
                                x06: 'P'
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        lx.load.remove();
                                        var returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        if (returnStr == 'REDIRECT') {
                                            apex.navigation.redirect(gReturn);
                                        } else if (returnStr.indexOf("ORA-") != -1) {
                                            alert("Error - " + gReturn);
                                        } else {
                                            /* fix on production... needs to be done differently on UT app
                                            var returnStrArr = returnStr.split('<|>');
                                            $(pThis).closest('tr').find('.irStatus').html(returnStrArr[0]);
                                            if (typeof returnStrArr[1] !== 'undefined') $(pThis).closest('tr').find('.irSubtype').text(returnStrArr[1]);*/
                                            $(".document_details_status").html(returnStr);
                                            partialRefresh();
                                        }
                                    }
                                }
                            );
                        } else {
                            $s("P0_DOC_PROCESS", vChkFooter);
                            $s("P0_DOC_PROCESS_2", vDocProc2);
                            apex.submit("APPLY_ACTION_CHANGES");
                        }
                    }
                }
            }
        });
}

function adtRefresh() {
    const lPgId = Number($v("pFlowStepId"));

    const reloadPages = [244, 441, 190, 30, 464, 348, 69, 223];
    if (reloadPages.includes(lPgId)) {
        location.reload();
        return;
    }

    const map = {
        308: "IR-COMMERCIAL",
        243: "IR-WAREHOUSE",
        198: "IR-DOC",
        347: "contIR",
    };
    const lIrId = map[lPgId] ?? "IR-HR_FORM";

    console.log('triggering apexrefresh on #' + lIrId);
    apex.event.trigger("#" + lIrId, "apexrefresh");
}

//runActionIR = lx.action.doc.runIR
function runActionIR(p_aka, pId, pThis, pNotifId) {
    var returnStr, vIR;
    var vDocProc2 = '';
    if ($(pThis).hasClass("feed-btn")) vIR = "F";
    else vIR = "R";
	  //console.log('runActionIR='+p_aka);
    lx.load.add();
    apex.server.process("DOCUMENT_ACTION_MSG", {
        x01: p_aka,
        x02: pId
    }, {
            dataType: 'text',
            success: function (dMsg) {
                var vMsg = dMsg;
                lx.load.remove();
                var vChkFooter = vMsg.substr(0, vMsg.indexOf(':'));
                vMsg = vMsg.replace(vChkFooter + ':', '');
                //console.log('2_vChkFooter='+vChkFooter);
                if (vChkFooter == 'RS' || vChkFooter == 'EMAIL' || vChkFooter == 'PRINT' || vChkFooter == 'PRINT_O' || vChkFooter == 'PRINT_I' || vChkFooter == 'LINK_DOC') {
                //console.log('3_vChkFooter='+vMsg);
                    lx.action.doc.executeMessage(vMsg, pThis);
                    return;
                }
                //console.log('4_vChkFooter');
                if (vChkFooter == 'COM') {
					/*var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert" style="margin:1.6rem;"><div class="t-Alert-wrap"><div class="t-Alert-icon" style="padding:1.2rem 1.6rem;"><span class="t-Icon"></span></div><div style="width:100%;padding:1.6rem 1.6rem 0rem 1.6rem;">Please enter your reason(s) for rejection.</div></div></div>';*/
					var dialogDiv = '<div id="test" style="height:110px;padding:16px;background-color: #e7e7e7;"><div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert" ><div class="t-Alert-wrap"><div class="t-Alert-icon" style="padding:1.2rem 1.6rem;"><span class="t-Icon"></span></div><div style="width:100%;padding:1.2rem 1.2rem 1.2rem 0rem;">' + lx.tran.get('DOC_AUTH_REJECTION') + '</div></div></div><div style="padding: 24px 24px 20px 24px;background-color: #ffffff;">' + '<textarea id="actionReason" style="width:100%;height: 60px;" placeholder="Comment"></textarea></div></div>';
                    $(dialogDiv).dialog({
                        modal: true,
                        resizable: false,
                        /*title: "Reject Document",*/
                        width: 690,
						height: 335,
                        close: function (event, ui) { $(this).dialog('close').remove(); },
                        buttons: [{
                            text: "Submit", click: function () {
                                apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                    x01: p_aka,
                                    x02: pId,
                                    x03: '',
                                    x06: vIR,
                                    x07: $v("actionReason")
                                }, {
                                        dataType: 'text',
                                        success: function (pData) {
                                            lx.load.remove();
                                            returnStr = pData.substr(0, pData.indexOf('~'));
                                            gReturn = pData.replace(returnStr + '~', '');
                                            if (returnStr == 'REDIRECT') {
                                                apex.navigation.redirect(gReturn);
                                            } else if (returnStr.indexOf("ORA-") != -1) {
                                                alert("Error - " + gReturn);
                                            } else {
                                                if ($(pThis).parent('.feed-actions').length == 1) {
                                                    setTimeout(function () {
                                                        lx.feed.notifyRefresh(pThis, 5, pId, p_aka);
                                                    }, 500);
                                                } else {
                                                    adtRefresh();
                                                    //$(pThis).closest('tr').find('.irStatus').html(returnStr);
                                                    //$(pThis).closest(".lxDropBtn").replaceWith(gReturn);
                                                }
                                            }
                                        }
                                    }
                                );
                                $(this).dialog("close");
                            }
                        }
                            /*, { text: "Cancel", click: function () { $(this).dialog("close"); } }*/]
                    });
                } else if (vChkFooter == 'ND') {
                    // Copy document dialog
                    var vArray = vMsg.split(':');
                    /*var dialogDiv = '<div id="test"><br/>&nbsp;Choose type of the document:</div>'; //apex.lang.getMessage("JS23")	*/
					var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert" style="margin:1.6rem;"><div class="t-Alert-wrap"><div class="t-Alert-icon" style="padding:1.2rem 1.6rem;"><span class="t-Icon"></span></div><div style="width:100%;padding:1.2rem 1.2rem 1.2rem 0rem;">'+ lx.tran.get('CHOOSE_DOC_TYPE') +'</div></div></div>';
                    var dialog_buttons = {};
                    var vCancel = lx.tran.get('CANCEL_BTN'); //apex.lang.getMessage("JS24");
                    if (vArray.length == 9) {
						
                        dialog_buttons[vCancel] = function () {
                            $(this).dialog('close');
                        }
                        dialog_buttons[vArray[1]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[4],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[0]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[3],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[2]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[5],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        $(dialogDiv).dialog({
                            modal: true,
                            resizable: false,
                            /*title: vArray[6],*/
                            width: 600,
                            buttons: dialog_buttons
                        });
						//lx.dialog.open({id:"CopyDoc", maxWidth: "600px", title: lx.tran.get('COPY_DOCUMENT'), html: dialogDiv, buttons: dialog_buttons});
                    }
                    // HR Documents
                    else if (vArray.length == 29) {
                        dialog_buttons[vArray[0]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[13],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[1]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[14],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[2]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[15],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[3]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[16],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[4]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[17],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[5]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[18],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[6]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[19],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[7]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[20],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[8]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[21],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[9]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[22],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[10]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[23],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[11]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[24],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }	
                            )
                        }
                        dialog_buttons[vArray[12]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[25],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vCancel] = function () {
                            $(this).dialog('close');
                        }

                        $(dialogDiv).dialog({
                            modal: true,
                            resizable: false,
                            title: vArray[26],
                            width: 500,
                            buttons: dialog_buttons
                        });
                    }
                    else {
                        dialog_buttons[vArray[0]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[2],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vArray[1]] = function () {
                            apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                                x01: p_aka,
                                x02: pId,
                                x03: '',
                                x04: vArray[3],
                                x06: vIR
                            }, {
                                    dataType: 'text',
                                    success: function (pData) {
                                        returnStr = pData.substr(0, pData.indexOf('~'));
                                        gReturn = pData.replace(returnStr + '~', '');
                                        apex.navigation.redirect(gReturn);
                                    }
                                }
                            )
                        }
                        dialog_buttons[vCancel] = function () {
                            $(this).dialog('close');
                        }

                        $(dialogDiv).dialog({
                            modal: true,
                            resizable: false,
                            title: vArray[4],
                            width: 690,
                            buttons: dialog_buttons
                        });
                    }
                }
                // End copy document dialog
                if (vChkFooter != 'ND' && vChkFooter != 'RS' && vChkFooter != 'EMAIL' && vChkFooter != 'COM') {
                    var vMsgConfirm;
                    // Line bellow was added to prevent showing document code that was concated to the end 
                    // of return statement of pkg_documents.get_warning_msg function.
                    vMsg = vMsg.substr(0, vMsg.indexOf(':'));
                    if (vMsg.indexOf("NO_MSG") == -1) vMsgConfirm = confirm(vMsg);
                    else vMsgConfirm = true;

                    if (vMsgConfirm) {
                        if (vChkFooter == 'CLD-INV,0' || vChkFooter == 'CLD-INV,1') {
                            if (confirm(apex.lang.getMessage("JS26")) == true) vDocProc2 = '1';
                            vChkFooter = vChkFooter.replace('CLD-INV,', '');
                        }
                        if (vChkFooter == '1') {
                            if (confirm(apex.lang.getMessage("CHANGE_FOOTER_TEXT")) == false) vChkFooter = '0';
                        }
                        var v03 = vChkFooter;
                        if (vChkFooter == 'PAID') v03 = 0;
                        if ($(pThis).parent('.feed-actions').length == 1) {
                            $(pThis).hide();
                            $(pThis).siblings().hide();
                            $(pThis).closest(".feed-actions").append("Processing Response");
                        }
                        lx.load.add();
                        apex.server.process("DOCUMENT_ACTION_EXECUTE_AJAX", {
                            x01: p_aka,
                            x02: pId,
                            x03: v03,
                            x05: vDocProc2,
                            x06: vIR
                        }, {
                                dataType: 'text',
                                success: function (pData) {
                                    lx.load.remove();
                                    returnStr = pData.substr(0, pData.indexOf('~'));
                                    gReturn = pData.replace(returnStr + '~', '');
                                    if (returnStr == 'REDIRECT') {
                                        apex.navigation.redirect(gReturn);
                                    } else if (returnStr.indexOf("ORA-") != -1) {
                                        alert("Error - " + gReturn);
                                    } else {
                                        if ($(pThis).parent('.feed-actions').length == 1) {
                                            setTimeout(function () {
                                                lx.feed.notifyRefresh(pThis, 5, pId, p_aka);
                                            }, 500);
                                        } else {
                                            adtRefresh();
                                            /*var lPgId = $v("pFlowStepId");
                                            var lIrId = (lPgId == 308 ? "IR-COMMERCIAL" : (lPgId == 243 ? "IR-WAREHOUSE" : (lPgId == 198 ? "IR-DOC" : (lPgId == 347 ? "contIR" : "IR-HR_FORM"))));
                                            //apex.region(lIrId).refresh();
                                            console.log('triggering apexrefresh on #'+lIrId);
                                            apex.event.trigger( "#"+lIrId, "apexrefresh" );*/
                                        }
                                    }
                                    if (vChkFooter == 'PAID') $("#docStat" + pId).html('PAID');
                                }
                            }
                        )
                    }
                }
            }
        });
}


lx.action.printMessage = function (pMsg, pType) {
    if (pType == 'S') {
        $('#uSuccessMessage').remove();
        $('.ui-lx-meni-container').after('<section id="uSuccessMessage" class="uRegion uWhiteRegion uMessageRegion clearfix"><div class="uRegionContent clearfix"><a class="uCloseMessage" onclick="$x_Remove(\'uSuccessMessage\')" href="javascript:void(0)"></a><img alt="" class="uCheckmarkIcon" src="/i/f_spacer.gif"><div class="uMessageText">' + pMsg + '</div></div></section>');
    } else {
        $('#uNotificationMessage').remove();
        $('.ui-lx-meni-container').after('<section id="uNotificationMessage" class="uRegion uWhiteRegion uMessageRegion clearfix"><div class="uRegionContent clearfix"><a class="uCloseMessage" onclick="$x_Remove(\'uNotificationMessage\')" href="javascript:void(0)"></a><img alt="" class="uWarningIcon" src="/i/f_spacer.gif"><div class="uMessageText">' + apex.lang.getMessage("JS33") + '<ul class="htmldbUlErr"><li>' + pMsg + '</li></ul></div></div></section>');
    }
};

/* ex function statusChange*/
lx.action.item.statusChange = function (pRec, pStatus) {
    apex.server.process("statusChange", {
        x01: pRec,
        x02: pStatus
    }, {
            dataType: "text",
            success: function (d) {
                if (pStatus == 'H')
                    $("#sts-item-" + pRec).text("ARCHIVED");
                else $("#sts-item-" + pRec).text("ACTIVE");
				location.reload();
            }
        });
};

lx.action.item.deleteIr = function (pRec) {
    apex.server.process("deleteIr", {
        x01: pRec
    }, {
            dataType: "text",
            success: function (d) {
				location.reload();
            }
        });
};

lx.action.helpdesk.deleteIr = function (pRec) {
    apex.server.process("deleteIr", {
        x01: pRec
    }, {
        dataType: "text",
        success: function () {
		location.reload();
            }
        });
};
